// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_row {
  height: 100%;
}
.main_row .main_col {
  display: flex;
  flex-direction: column;
}

.img_row {
  position: relative;
  height: 250px;
}
.img_row .cross {
  height: 35px;
  width: 35px;
  position: absolute;
  top: 13px;
  right: 13px;
  z-index: 999;
}
.img_row .item_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img_row .points_block {
  position: absolute;
  left: 24px;
  bottom: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img_row .points_block .points {
  font-family: Slat;
  font-size: 24px;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: #f4ece1;
  margin-right: 7px;
}
.img_row .points_block .bull {
  height: 25px;
  width: 25px;
}

.content_block {
  padding: 35px 20px 12px;
  flex-grow: 1;
}
.content_block .content_col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content_block .text_block .item_name {
  font-family: Slat;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
  color: #f4ece1;
  margin-bottom: 10px;
}
.content_block .text_block .description {
  font-family: AppFontLight;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #f4ece1;
}
.content_block .nav_block .button_info {
  font-family: AppFont;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: start;
  color: #fff;
  margin-bottom: 12px;
}
.content_block .nav_block .button_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content_block .nav_block .button_block .button_card {
  width: 45%;
}
.content_block .nav_block .button_block .button_card .img_button_block {
  background: #2b2527;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 110px;
}
.content_block .nav_block .button_block .button_card .img_button_block ion-img {
  height: 70%;
}
.content_block .nav_block .button_block .button_card .button {
  background: var(--ion-color-primary);
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content_block .nav_block .button_block .button_card .button p {
  font-family: Slat;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.06em;
  text-align: center;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/loyalty-modal-info/loyalty-modal-info.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;;AAGA;EACE,kBAAA;EAEA,aAAA;AADF;AAGE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAHN;AAMI;EACE,YAAA;EACA,WAAA;AAJN;;AASA;EACE,uBAAA;EACA,YAAA;AANF;AAQE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AANJ;AAUI;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AARN;AAWI;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AATN;AAcI;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAZN;AAeI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAbN;AAeM;EACE,UAAA;AAbR;AAeQ;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAbV;AAeU;EACE,WAAA;AAbZ;AAiBQ;EACE,oCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAfV;AAiBU;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AAfZ","sourcesContent":[".main_row {\n  height: 100%;\n\n  .main_col {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.img_row {\n  position: relative;\n  // background: url(\"../../../assets/loyalty/bacground_loyalty_info.png\") no-repeat top/120%;\n  height: 250px;\n\n  .cross {\n    height: 35px;\n    width: 35px;\n    position: absolute;\n    top: 13px;\n    right: 13px;\n    z-index: 999;\n  }\n\n  .item_img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .points_block {\n    position: absolute;\n    left: 24px;\n    bottom: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .points {\n      font-family: Slat;\n      font-size: 24px;\n      line-height: 22px;\n      letter-spacing: 0em;\n      text-align: left;\n      color: #f4ece1;\n      margin-right: 7px;\n    }\n\n    .bull {\n      height: 25px;\n      width: 25px;\n    }\n  }\n}\n\n.content_block {\n  padding: 35px 20px 12px;\n  flex-grow: 1;\n\n  .content_col {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .text_block {\n    .item_name {\n      font-family: Slat;\n      font-size: 32px;\n      line-height: 40px;\n      letter-spacing: 0em;\n      text-align: left;\n      color: #f4ece1;\n      margin-bottom: 10px;\n    }\n\n    .description {\n      font-family: AppFontLight;\n      font-size: 15px;\n      line-height: 20px;\n      letter-spacing: 0em;\n      text-align: left;\n      color: #f4ece1;\n    }\n  }\n\n  .nav_block {\n    .button_info {\n      font-family: AppFont;\n      font-size: 14px;\n      line-height: 19px;\n      letter-spacing: 0em;\n      text-align: start;\n      color: #fff;\n      margin-bottom: 12px;\n    }\n\n    .button_block {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .button_card {\n        width: 45%;\n\n        .img_button_block {\n          background: #2b2527;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          height: 110px;\n\n          ion-img {\n            height: 70%;\n          }\n        }\n\n        .button {\n          background: var(--ion-color-primary);\n          height: 40px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          p {\n            font-family: Slat;\n            font-size: 13px;\n            line-height: 16px;\n            letter-spacing: 0.06em;\n            text-align: center;\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
